var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "#333",
    width: 22,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.467 0.934937H3.27109C1.9263 0.934937 0.826019 2.03522 0.826019 3.38001V11.6199C0.826019 12.9647 1.9263 14.065 3.27109 14.065H13.467C14.8118 14.065 15.9121 12.9647 15.9121 11.6199V3.38001C15.9121 2.01077 14.8118 0.934937 13.467 0.934937Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.467 14.0652L3.27106 14.0652C1.92628 14.0652 0.826002 12.9893 0.826002 11.6201L0.826003 8.73894C0.826002 10.1082 1.92628 11.184 3.27106 11.184L13.4671 11.184C14.8118 11.184 15.9121 10.0837 15.9121 8.73894L15.9121 11.6201C15.9121 12.9649 14.8118 14.0652 13.467 14.0652Z",
    fill: "black",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3647 2.27974C21.218 2.30419 21.0713 2.37754 20.9491 2.45089L17.1348 4.65146V10.324L20.9735 12.5246C21.6826 12.9403 22.5628 12.6958 22.9785 11.9867C23.1007 11.7666 23.1741 11.5221 23.1741 11.2532V3.69788C23.1741 2.7932 22.3183 2.05968 21.3647 2.27974Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOn);
export default __webpack_public_path__ + "static/media/camera-on.4ed1bad5.svg";
export { ForwardRef as ReactComponent };